/**
 * Isometric Math - 64x32 Diamond Projection (2:1 standard)
 */

export const TILE_WIDTH = 64;
export const TILE_HEIGHT = 32;

export interface ScreenCoord {
  x: number;
  y: number;
}

export function tileToScreen(
  tileX: number,
  tileY: number,
  cameraOffsetX = 0,
  cameraOffsetY = 0
): ScreenCoord {
  const sx = (tileX - tileY) * (TILE_WIDTH / 2) + cameraOffsetX;
  const sy = (tileX + tileY) * (TILE_HEIGHT / 2) + cameraOffsetY;
  return { x: sx, y: sy };
}

export function screenToTile(
  screenX: number,
  screenY: number,
  cameraOffsetX = 0,
  cameraOffsetY = 0
): { x: number; y: number } {
  const relX = screenX - cameraOffsetX;
  const relY = screenY - cameraOffsetY;

  const tileX = (relX / (TILE_WIDTH / 2) + relY / (TILE_HEIGHT / 2)) / 2;
  const tileY = (relY / (TILE_HEIGHT / 2) - relX / (TILE_WIDTH / 2)) / 2;

  return { x: tileX, y: tileY };
}
